export default "__VITE_ASSET__TA_YG59l__"